import React, { useEffect } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./sessionLayout.css";
import { fetchSession, selectSession } from "../../sessionBuilderSlice";
import SidebarTour from "./sidebarTour";

const TABS = [
  { to: "mode", label: "Mode", icon: "fa-solid fa-sliders", tourKey: "tab-mode" },
  { to: "settings", label: "Settings", icon: "fa-solid fa-gear", tourKey: "tab-settings" },
  { to: "activities", label: "Activities", icon: "fa-solid fa-layer-group", tourKey: "tab-activities" },
  { to: "review", label: "Review", icon: "fa-solid fa-flag-checkered", tourKey: "tab-review" },
  { to: "participants", label: "Participants", icon: "fa-solid fa-users", tourKey: "tab-participants" },
];

const SessionLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const session = useSelector(selectSession);
  const currentTheme = useSelector(
    (s) => s.theme?.currentTheme || s.theme?.data?.themename || null
  );
  const themeDataTitle = useSelector((s) => s.theme?.data?.title || s.theme?.data?.themeName);

  useEffect(() => {
    dispatch(fetchSession());
  }, [dispatch]);

  const title = session?.title || themeDataTitle || "Untitled Session";
  const isLive = (session?.mode ?? "live") === "live";
  const onActivitiesPage = location.pathname.endsWith("/session/activities");

  return (
    <div className="sl-wrap">
      {onActivitiesPage && currentTheme && <SidebarTour />}

      <aside className="sl-sidebar">
        <div className="sl-session-head">
          <div className="sl-session-label">SESSION</div>
          <div className="sl-session-title" title={title}>
            {title}
          </div>
          <span className={`sl-mode-pill ${isLive ? "sl-live" : "sl-selfpaced"}`}>
            {isLive ? "Live" : "Self-Paced"}
          </span>
        </div>

        <button
          className="sl-present"
          data-tour="present-btn"
          onClick={() => navigate("/admin/session/present")}
          disabled={!isLive}
          title={!isLive ? "Self-Paced sessions don't need a presenter — participants play on their own." : "Present this session"}
        >
          <i className="fa-solid fa-play"></i> Present
        </button>
        <button className="sl-back" onClick={() => navigate("/admin")}>
          <i className="fa-solid fa-arrow-left"></i> Back to Sessions
        </button>

        <nav className="sl-tabs">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-tour={t.tourKey}
              className={({ isActive }) => `sl-tab ${isActive ? "sl-tab-active" : ""}`}
            >
              <i className={t.icon}></i>
              <span>{t.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="sl-content">
        {!currentTheme ? (
          <div className="sl-no-theme">
            <i className="fa-solid fa-triangle-exclamation"></i>
            <p>No session selected. Go back and open a session.</p>
            <button className="save-and-continue" onClick={() => navigate("/admin")}>
              Back to Sessions
            </button>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
};

export default SessionLayout;
